import alt from "../alt";

class TicketActions {
  constructor() {
    this.generateActions(
      "updateTickets",
      "fetchAll",
      "fetchOne",
      "fetchFailed",
      "deleteTicket",
      "downloadPdf",
      "cancelTicketTransfer",
      "resendTicketTransfer",
      "resetAcceptTicketTransfer"
    );
  }

  updateTicket(id, ticket) {
    return { id, ticket };
  }

  transferTickets(ids, destinationEmail) {
    return { ids, destinationEmail };
  }

  acceptTicketTransfer(id, token) {
    return { id, token };
  }
}

export default alt.createActions(TicketActions);



// WEBPACK FOOTER //
// ./src/app/actions/TicketActions.js